import React, { useEffect, useMemo, useRef, useState } from "react";

const MockQuickFilter = ({ label, options, value = [], onChange, ariaLabel }) => {
    const [open, setOpen] = useState(false);
    const rootRef = useRef(null);
    const optionValues = useMemo(() => new Set(options.map((o) => o.value)), [options]);
    const activeValues = useMemo(
        () => value.filter((v) => optionValues.has(v)),
        [value, optionValues]
    );
    const activeCount = activeValues.length;

    useEffect(() => {
        if (activeValues.length !== value.length) {
            onChange(activeValues);
        }
    }, [activeValues, value, onChange]);

    useEffect(() => {
        const onPointerDown = (e) => {
            if (rootRef.current && !rootRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", onPointerDown);
        return () => document.removeEventListener("mousedown", onPointerDown);
    }, []);

    const toggleValue = (optionValue) => {
        const next = activeValues.includes(optionValue)
            ? activeValues.filter((v) => v !== optionValue)
            : [...activeValues, optionValue];
        onChange(next);
    };

    return (
        <div className="clk-mk-quick-filter" ref={rootRef}>
            <button
                type="button"
                className={`clk-mk-filter-btn${activeCount ? " is-active" : ""}${open ? " is-open" : ""}`}
                onClick={() => setOpen((v) => !v)}
                aria-label={ariaLabel || label}
                aria-expanded={open}
            >
                {label}
                {activeCount > 0 && <span className="clk-mk-filter-count">{activeCount}</span>}
                <span className="clk-mk-filter-caret">▾</span>
            </button>
            {open && (
                <ul className="clk-mk-filter-menu" role="listbox" aria-label={ariaLabel || label}>
                    {options.map((opt) => (
                        <li key={opt.value}>
                            <button
                                type="button"
                                role="option"
                                aria-selected={activeValues.includes(opt.value)}
                                className={activeValues.includes(opt.value) ? "is-active" : ""}
                                onClick={() => toggleValue(opt.value)}
                            >
                                <input type="checkbox" readOnly checked={activeValues.includes(opt.value)} tabIndex={-1} />
                                {opt.color && <i style={{ background: opt.color }} />}
                                <span>{opt.label}</span>
                            </button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default MockQuickFilter;
